import { render, staticRenderFns } from "./PhoneBookForm.vue?vue&type=template&id=1d393090&"
import script from "./PhoneBookForm.vue?vue&type=script&lang=js&"
export * from "./PhoneBookForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports